import React from 'react';
import { getNameByKey } from '../../../../lib/utils/UtilsCommon';
import { getDownloadQrDataUrl } from '../../../../lib/utils/downloadQrCode';

/**
 * 可选参数
 */
interface IProps {
	site?: any;
}

/**
 * 页脚
 */
class LayoutFooter extends React.PureComponent<IProps> {
	state = {
		host: '',
		qrCodeSrc: '',
	};
	componentDidMount(): void {
		this.setState({
			host: location.host,
		});
		// 获取动态下载二维码
		getDownloadQrDataUrl(208)
			.then((dataUrl) => {
				this.setState({ qrCodeSrc: dataUrl });
			})
			.catch(() => {
				// 失败则不显示二维码
			});
	}

	/**
	 * render
	 */
	public render(): any {
		const { host } = this.state;
		return (
			<div className="p-layout-footer">
				<div className="relevant">
					<div className="relevant-list">
						<ul>
							<li>兴趣岛</li>
							<li>
								<a href="/qlchat-edu/about">公司简介</a>
							</li>
							<li>
								<a href="https://mp.weixin.qq.com/s/suFzyrlaYPgPqraRHbcL2w">
									市场合作
								</a>
							</li>
							<li>
								<a href="https://www.liepin.com/company/8975743">加入我们</a>
							</li>
							<li>
								<a href="/sincerity-compliance">诚信合规</a>
							</li>
						</ul>
						<ul>
							<li>联系我们</li>
							<li>电话：400-8328-080（工作日9:30-22:00）</li>
							<li>地址：广州市天河区奥体南路9号兴趣岛办公大楼</li>
							<li>
								邮箱：jiamin.deng@qlchat.com <br />
							</li>
							<li>
								监察监督：jiancha@qlchat.com <br />
							</li>
						</ul>
					</div>
					<div className="qr-box-list">
						<div className="qr-box">
							<div className="qr-name">公众号</div>
							<img
								src="https://img.qlchat.com/qlLive/activity/image/TY799MRE-8VXR-CUX8-1687686865072-F6EYQBMKYT3L.png?x-oss-process=image/format,webp"
								alt=""
							/>
						</div>
						<div className="qr-box">
							<div className="qr-name">APP下载</div>
							{this.state.qrCodeSrc ? (
								<img src={this.state.qrCodeSrc} alt="" />
							) : null}
						</div>
					</div>
				</div>
				<div className="copyright">
					<p>
						copyright C 2016-2022 {getNameByKey()} inc. All Right Reserved{' '}
						{getNameByKey('comp')} 版权所有
					</p>
					<p>
						<span>
							<a href="https://beian.miit.gov.cn/">{getNameByKey('num')}</a>
						</span>
						<span>
							<a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010602005588">
								粤公网安备 44010602005588号
							</a>
						</span>
						{/* <span>
							<a href="http://img.qlchat.com/qlLive/liveCommon/wangwenzheng.jpg?x-oss-process=image/format,webp">粤网文【2020】4310-268号</a>
						</span> */}
						<span>
							<a href="https://media.qianliaowang.com/xqd/tools/activity/image/2025042911/2JHB6T5X-RL7W-Q8XT-1745915030795-CN3ZLHHCKRCV.png">
								增值电信业务经营许可证：粤B-20250613
							</a>
						</span>
						<span>
							<a href="http://www.gdis.cn/">互联网清理整顿</a>
						</span>
					</p>
				</div>
			</div>
		);
	}
}

export default LayoutFooter;
